import { sendTelemetryEvent, sendUserTelemetryEvent } from 'services/requestAgent';
import { getImRef } from 'components/utils';
import { getCustomerId, isTokenValid } from 'services/authUtils';

/**
 * Client lifecycle events reported as telemetry. The client is integration-agnostic — it only knows
 * about "telemetry events"; the backend decides what to do with them (e.g. forward to a marketing
 * provider).
 */
export const TELEMETRY_EVENTS = {
  REGISTRATION_START: 'REGISTRATION_START',
  REGISTRATION_USER_SUCCESS: 'REGISTRATION_USER_SUCCESS',
  REGISTRATION_CUSTOMER_SUCCESS: 'REGISTRATION_CUSTOMER_SUCCESS',
  CUSTOMER_VERIFICATION_START: 'CUSTOMER_VERIFICATION_START'
};

/**
 * Reports a telemetry event to the backend. Fire-and-forget: it never throws and never blocks the
 * UI. When a valid session token is present the authenticated endpoint is used, otherwise the
 * public (Basic Auth) endpoint.
 *
 * @param {string} event one of {@link TELEMETRY_EVENTS}
 * @param {{ authenticated?: boolean, customerNumber?: string }} [options]
 */
export const trackTelemetryEvent = async (event, options = {}) => {
  const { authenticated = isTokenValid(), customerNumber } = options;
  const payload = {
    event,
    im_ref: getImRef() || undefined,
    customer_number: customerNumber || getCustomerId() || undefined
  };
  try {
    if (authenticated) {
      await sendUserTelemetryEvent(payload);
    } else {
      await sendTelemetryEvent(payload);
    }
  } catch (e) {
    // Telemetry must never break the UI.
    // eslint-disable-next-line no-console
    console.error('telemetry event failed', e);
  }
};
